import { Paper, Title, Text } from '@mantine/core';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useRevenue } from '@/hooks/useRevenue';

export function RevenueChart() {
  const { data: revenue, isLoading } = useRevenue();

  const chartData = aggregateMonthlyRevenue(revenue ?? []);

  if (isLoading) return <Text>Lade Umsatzdaten...</Text>;

  return (
    <Paper withBorder p="md" radius="md">
      <Title order={4} mb="md">
        Monatliche Umsätze
      </Title>
      {chartData.length === 0 ? (
        <Text c="dimmed">Noch keine Umsatzdaten vorhanden.</Text>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip formatter={(value: number) => `${value.toFixed(2)} EUR`} />
            <Bar dataKey="amount" fill="var(--mantine-color-blue-6)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
}

function aggregateMonthlyRevenue(
  revenue: { monthlyRevenue: { yearMonth: string; amount: number }[] }[],
) {
  const monthly = new Map<string, number>();
  for (const company of revenue) {
    for (const entry of company.monthlyRevenue) {
      monthly.set(entry.yearMonth, (monthly.get(entry.yearMonth) ?? 0) + entry.amount);
    }
  }
  return Array.from(monthly.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .slice(-12)
    .map(([month, amount]) => ({ month, amount }));
}
